import styled from '@emotion/styled';
import { Text } from '@mantine/core';

import * as baseDefinitions from './baseDefinitions';

const mediaQuerySmallScreen = '@media (max-width: 599px)';

export const DisplayLarge = styled(Text)`
  ${baseDefinitions.Default64px}
  font-weight: 700;
  line-height: 72px;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default48px}
    font-weight: 700;
    line-height: 64px;
  }
`;

export const DisplayMedium = styled(Text)`
  ${baseDefinitions.Default48px}
  font-weight: 700;
  line-height: 64px;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default40px}
    font-weight: 700;
    letter-spacing: -0.015em;
  }
`;

export const TitleXXLarge = styled(Text)`
  ${baseDefinitions.Default64px}
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default48px}
    line-height: 52px;
  }
`;

export const TitleXLarge = styled(Text)`
  ${baseDefinitions.Default48px}
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default40px}
    line-height: 44px;
  }
`;

export const TitleLarge = styled(Text)`
  ${baseDefinitions.Default40px}
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default32px}
    line-height: 36px;
  }
`;

export const TitleMedium = styled(Text)`
  ${baseDefinitions.Default32px}
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default24px}
    line-height: 32px;
  }
`;

export const TitleSmall = styled(Text)`
  ${baseDefinitions.Default24px}
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default18px};
    font-family: Poppins, sans-serif;
    font-weight: 600;
    line-height: 24px;
  }
`;

export const TitleXSmall = styled(Text)`
  ${baseDefinitions.Default18px};
  font-family: Poppins, sans-serif;
  font-weight: 600;
  line-height: 24px;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default16px};
    font-family: Poppins, sans-serif;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const TitleXXSmall = styled(Text)`
  font-size: 14px;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  ${mediaQuerySmallScreen} {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
`;

export const ParagraphLarge = styled(Text)`
  ${baseDefinitions.Default18px};
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default16px};
  }
`;

export const ParagraphMedium = styled(Text)`
  ${baseDefinitions.Default16px};
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default14px};
  }
`;

export const ParagraphSmall = styled(Text)`
  ${baseDefinitions.Default14px};
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default12px};
    line-height: 20px;
  }
`;

export const ParagraphXSmall = styled(Text)`
  ${baseDefinitions.Default12px};
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default10px};
  }
`;

export const ParagraphLargeStrong = styled(Text)`
  ${baseDefinitions.Default18px};
  font-weight: 600;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default16px};
    font-weight: 600;
  }
`;

export const ParagraphMediumStrong = styled(Text)`
  ${baseDefinitions.Default16px};
  font-weight: 600;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default14px};
    font-weight: 600;
  }
`;

export const ParagraphSmallStrong = styled(Text)`
  ${baseDefinitions.Default14px};
  font-weight: 600;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default12px};
    font-weight: 600;
    line-height: 20px;
  }
`;

export const ParagraphXSmallStrong = styled(Text)`
  ${baseDefinitions.Default12px};
  font-weight: 600;

  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default10px};
    font-weight: 600;
  }
`;

export const LabelLarge = styled(Text)`
  ${baseDefinitions.Default18px};
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default16px};
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.01em;
  }
`;

export const LabelMedium = styled(Text)`
  ${baseDefinitions.Default16px};
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default14px};
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.01em;
  }
`;

export const LabelSmall = styled(Text)`
  ${baseDefinitions.Default14px};
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default12px};
    font-weight: 500;
    letter-spacing: -0.01em;
  }
`;

export const LabelXSmall = styled(Text)`
  ${baseDefinitions.Default12px};
  font-weight: 500;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default10px};
    font-weight: 500;
    line-height: 12px;
  }
`;

export const LabelLargeStrong = styled(Text)`
  ${baseDefinitions.Default18px};
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default16px};
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.01em;
  }
`;

export const LabelMediumStrong = styled(Text)`
  ${baseDefinitions.Default16px};
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default14px};
    font-weight: 600;
    line-height: 16px;
    letter-spacing: -0.01em;
  }
`;

export const LabelSmallStrong = styled(Text)`
  ${baseDefinitions.Default14px};
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default12px};
    font-weight: 600;
    letter-spacing: -0.01em;
  }
`;

export const LabelXSmallStrong = styled(Text)`
  ${baseDefinitions.Default12px};
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.01em;
  ${mediaQuerySmallScreen} {
    ${baseDefinitions.Default10px};
    font-weight: 600;
    line-height: 12px;
  }
`;
